import React from 'react'

export default function AnimatedBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] rounded-full bg-neon-purple/20 blur-[120px] animate-pulse-glow" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full bg-neon-cyan/15 blur-[100px] animate-pulse-glow-delayed" />
      <div className="absolute top-[40%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[400px] h-[400px] rounded-full bg-neon-pink/10 blur-[120px] animate-pulse-glow-slow" />
      <div className="absolute inset-0 grid-pattern opacity-30" />
    </div>
  )
}
